import React, { useEffect } from "react";
import Router from "./Router";
import { updateStore } from "./utils/store";

const App = () => {
  useEffect(() => {
    if (!localStorage.getItem("store:speech-evaluation")) {
      updateStore();
    }
  }, []);
  console.log("Version:-", "1.5.3-beta", "Env:", process.env.REACT_APP_ENV);
  return <Router />;
};

export default App;
